'use client';

import { c as _c } from "react/compiler-runtime";
import { useMap } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';
import { type RoutePreviewPoint } from './route-preview.ts';
const SINGLE_STOP_ZOOM = 10;
type RouteMapBoundsProps = {
  defaultCenter: RoutePreviewPoint;
  defaultZoom: number;
  points: RoutePreviewPoint[];
};
export const RouteMapBounds = t0 => {
  const $ = _c(6);
  const {
    defaultCenter,
    defaultZoom,
    points
  } = t0;
  const map = useMap();
  let t1;
  let t2;
  if ($[0] !== defaultCenter || $[1] !== defaultZoom || $[2] !== map || $[3] !== points) {
    t1 = () => {
      if (!map) {
        return;
      }
      if (points.length === 0) {
        map.setCenter(defaultCenter);
        map.setZoom(defaultZoom);
        return;
      }
      if (points.length === 1) {
        map.setCenter(points[0]);
        map.setZoom(SINGLE_STOP_ZOOM);
        return;
      }
      const bounds = points.reduce(_temp, {
        east: points[0].lng,
        north: points[0].lat,
        south: points[0].lat,
        west: points[0].lng
      });
      map.fitBounds(bounds, 80);
    };
    t2 = [defaultCenter, defaultZoom, map, points];
    $[0] = defaultCenter;
    $[1] = defaultZoom;
    $[2] = map;
    $[3] = points;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  return null;
};
function _temp(currentBounds, point) {
  return {
    east: Math.max(currentBounds.east, point.lng),
    north: Math.max(currentBounds.north, point.lat),
    south: Math.min(currentBounds.south, point.lat),
    west: Math.min(currentBounds.west, point.lng)
  };
}